import { queryOptions } from "@tanstack/react-query";
import { AdvisorKeys } from "web_myplann/Api/Advisor/AdvisorKeys";
import {
	type GetAgentAssignedV2FetchResponse,
	getAgentAssignedV2,
	type UserAgentStatusEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const assignedAgentsQueryOptions = (
	filterStatus?: UserAgentStatusEnum,
) =>
	queryOptions({
		queryKey: AdvisorKeys.assignedAgents(filterStatus),
		queryFn: processResponse<unknown, GetAgentAssignedV2FetchResponse>(() =>
			getAgentAssignedV2(filterStatus),
		),
	});
